import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import { useForm } from '../../lib/useForm';
import postObject from '../../lib/postObject';
import ImageUpload from '../../components/imageUpload';

const ProductCreateModal = ({ closeMainModal, reload }) => {
  const [product, handleChange] = useForm({ name: '', description: '', price: '', productUrl: '' });
  const [image, setImage] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!product.name || !product.description || !product.price || !product.productUrl) {
      setError('Please fill in all required fields');
      return false;
    }
    if (!image) {
      setError('Please select an image');
      return false;
    }
    return true;
  };

  const saveProduct = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      await postObject('products', { ...product, image });
      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create product. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Product</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveProduct(); }}>
          <Form.Input
            name="name"
            label="Name"
            placeholder="Enter product name"
            value={product.name}
            onChange={handleChange}
            required
          />

          <Form.Textarea
            name="description"
            label="Description"
            placeholder="Enter product description"
            value={product.description}
            onChange={handleChange}
            required
          />

          <Form.Input
            name="price"
            label="Price"
            placeholder="Enter price"
            type="number"
            min="0"
            step="0.01"
            value={product.price}
            onChange={handleChange}
            required
          />

          <Form.Input
            name="productUrl"
            label="URL"
            placeholder="Enter product URL"
            type="url"
            value={product.productUrl}
            onChange={handleChange}
            required
          />

          <ImageUpload
            label="Photo"
            required
            uploadText="Click here to upload photo"
            alt="Product Preview"
            onChange={(value) => setImage(value)}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveProduct}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default ProductCreateModal;
